"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _topicService = require("@insided/shared/services/topicService");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _utils = require("./utils");

var _search2 = require("./search");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Get the current logged-in user ID
 * Returns null if user is not logged in or in non-browser environment
 */
function getCurrentUserId() {
  if (!(0, _utils.isBrowser)()) {
    return null;
  }

  try {
    var userId = (0, _insidedDataStorage.getInsidedData)('user').userid;
    return userId ? Number(userId) : null;
  } catch (_unused) {
    return null;
  }
}
/**
 * Content instance for a specific content type and optional ID
 * privateId is optional - required only for actions like like, unlike, vote, etc.
 * Can be used without privateId for search functionality
 */


var ContentInstance = /*#__PURE__*/function () {
  function ContentInstance(_contentType, _privateId) {
    var _this = this;

    (0, _classCallCheck2.default)(this, ContentInstance);
    (0, _defineProperty2.default)(this, "contentType", void 0);
    (0, _defineProperty2.default)(this, "privateId", void 0);
    (0, _defineProperty2.default)(this, "like", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(likedBy) {
        var _this$validateContent, contentType, privateId, userId;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$validateContent = _this.validateContentAndId(likedBy), contentType = _this$validateContent.contentType, privateId = _this$validateContent.privateId, userId = _this$validateContent.userId;
                _context.next = 3;
                return (0, _topicService.like)(contentType, privateId, userId);

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)(this, "unlike", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(unlikedBy) {
        var _this$validateContent2, contentType, privateId, userId;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$validateContent2 = _this.validateContentAndId(unlikedBy), contentType = _this$validateContent2.contentType, privateId = _this$validateContent2.privateId, userId = _this$validateContent2.userId;
                _context2.next = 3;
                return (0, _topicService.unlike)(contentType, privateId, userId);

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)(this, "vote", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(votedBy) {
        var _this$validateContent3, contentType, privateId, userId;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$validateContent3 = _this.validateContentAndId(votedBy), contentType = _this$validateContent3.contentType, privateId = _this$validateContent3.privateId, userId = _this$validateContent3.userId;
                _context3.next = 3;
                return (0, _topicService.vote)(contentType, privateId, userId);

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)(this, "unvote", /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(unvotedBy) {
        var _this$validateContent4, contentType, privateId, userId;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$validateContent4 = _this.validateContentAndId(unvotedBy), contentType = _this$validateContent4.contentType, privateId = _this$validateContent4.privateId, userId = _this$validateContent4.userId;
                _context4.next = 3;
                return (0, _topicService.unvote)(contentType, privateId, userId);

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)(this, "likeReply", /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(replyId, likedBy) {
        var userId;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                userId = likedBy !== null && likedBy !== void 0 ? likedBy : getCurrentUserId();

                if (userId) {
                  _context5.next = 3;
                  break;
                }

                throw new Error('User ID is required. User must be logged in or provide a userId parameter.');

              case 3:
                _context5.next = 5;
                return (0, _topicService.likeReply)(_this.contentType, replyId, userId);

              case 5:
                return _context5.abrupt("return", _context5.sent);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x5, _x6) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)(this, "unlikeReply", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(replyId, unlikedBy) {
        var userId;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                userId = unlikedBy !== null && unlikedBy !== void 0 ? unlikedBy : getCurrentUserId();

                if (userId) {
                  _context6.next = 3;
                  break;
                }

                throw new Error('User ID is required. User must be logged in or provide a userId parameter.');

              case 3:
                _context6.next = 5;
                return (0, _topicService.unlikeReply)(_this.contentType, replyId, userId);

              case 5:
                return _context6.abrupt("return", _context6.sent);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x7, _x8) {
        return _ref6.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)(this, "search", /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(query, options) {
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if ((0, _utils.isBrowser)()) {
                  _context7.next = 2;
                  break;
                }

                throw new Error('Search can only be used in browser environment');

              case 2:
                _context7.next = 4;
                return _search2.Search.search(_objectSpread({
                  query: query,
                  contentType: _this.contentType
                }, options));

              case 4:
                return _context7.abrupt("return", _context7.sent);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x9, _x10) {
        return _ref7.apply(this, arguments);
      };
    }());

    if (!_contentType) {
      throw new Error("ContentType is required. Received: ".concat(_contentType));
    }

    this.contentType = _contentType;
    this.privateId = _privateId;
  }
  /**
   * Common validation for like, unlike, vote, unvote operations
   * Validates contentType, privateId, and userId
   */


  (0, _createClass2.default)(ContentInstance, [{
    key: "validateContentAndId",
    value: function validateContentAndId(userId) {
      if (!this.contentType) {
        throw new Error('ContentType is required');
      }

      if (this.privateId === undefined || typeof this.privateId !== 'number' || Number.isNaN(this.privateId)) {
        throw new Error("privateId is required for this operation. Create ContentInstance with a privateId (e.g., Content.Idea(123))");
      }

      var finalUserId = userId !== null && userId !== void 0 ? userId : getCurrentUserId();

      if (!finalUserId) {
        throw new Error('User ID is required. User must be logged in or provide a userId parameter.');
      }

      return {
        contentType: this.contentType,
        privateId: this.privateId,
        userId: finalUserId
      };
    }
    /**
     * Like a topic
     * @param likedBy - User ID to like as. If not provided, uses the current logged-in user.
     *                   In most cases, this should be the logged-in user.
     */

  }]);
  return ContentInstance;
}();
/**
 * Content API factory for creating content instances
 * Note: Methods don't use 'this' but are kept as instance methods for API consistency
 */

/* eslint-disable class-methods-use-this */


var ContentApi = /*#__PURE__*/function () {
  function ContentApi() {
    (0, _classCallCheck2.default)(this, ContentApi);
  }

  (0, _createClass2.default)(ContentApi, [{
    key: "Article",
    value:
    /**
     * Create an Article instance
     * @param privateId - Optional. Required only for actions like like, unlike, etc.
     *                    Can be omitted for search functionality.
     */
    function Article(privateId) {
      return new ContentInstance('article', privateId);
    }
    /**
     * Create a Question instance
     * @param privateId - Optional. Required only for actions like like, unlike, etc.
     *                    Can be omitted for search functionality.
     */

  }, {
    key: "Question",
    value: function Question(privateId) {
      return new ContentInstance('question', privateId);
    }
    /**
     * Create a Conversation instance
     * @param privateId - Optional. Required only for actions like like, unlike, etc.
     *                    Can be omitted for search functionality.
     */

  }, {
    key: "Conversation",
    value: function Conversation(privateId) {
      return new ContentInstance('conversation', privateId);
    }
    /**
     * Create an Idea instance
     * @param privateId - Optional. Required only for actions like like, unlike, vote, etc.
     *                    Can be omitted for search functionality.
     */

  }, {
    key: "Idea",
    value: function Idea(privateId) {
      return new ContentInstance('idea', privateId);
    }
    /**
     * Create a ProductUpdate instance
     * @param privateId - Optional. Required only for actions like like, unlike, etc.
     *                    Can be omitted for search functionality.
     */

  }, {
    key: "ProductUpdate",
    value: function ProductUpdate(privateId) {
      return new ContentInstance('productUpdate', privateId);
    }
    /**
     * Search across all content types (ideas, questions, articles, conversations, product updates)
     * This is a convenience method that searches all available content types at once
     *
     * Follows the same behavior as the UI Search component - when no content type is specified,
     * no content_type filter is added, allowing Algolia to return all content types.
     *
     * @param query - The search query string
     * @param options - Optional search options (limit, etc.)
     * @returns Promise with search results from all content types
     * @example
     * const results = await Content.search('dark theme', { limit: 20 })
     */

  }, {
    key: "search",
    value: function () {
      var _search = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(query, options) {
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if ((0, _utils.isBrowser)()) {
                  _context8.next = 2;
                  break;
                }

                throw new Error('Search can only be used in browser environment');

              case 2:
                _context8.next = 4;
                return _search2.Search.search(_objectSpread({
                  query: query
                }, options));

              case 4:
                return _context8.abrupt("return", _context8.sent);

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function search(_x11, _x12) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }]);
  return ContentApi;
}();
/* eslint-enable class-methods-use-this */


var Content = new ContentApi();
exports.Content = Content;